import { gql } from "@grandvisionhq/graphql";
const GET_MY_WISHLIST_ID = gql`
  query GetMyWishlistId {
    me {
      id
      wishlist {
        id
      }
    }
  }
`;
export {
  GET_MY_WISHLIST_ID as default
};
//# sourceMappingURL=get-my-wishlist-id.js.map
